class ModuleModal {
  constructor(template) {
    this.template = template;
  }
  /**
   * เปิด modal
   * @param {string} id - รหัส id ของ modal
   */
  openModal(element) {
    $(element).modal('show');
  }
  /**
   * ปิด modal
   * @param {string} id - รหัส id ของ modal
   */
  closeModal(element) {
    $(element).modal('hide');
  }
  /**
   * ตั้งค่ารายละเอียดของ modal
   * @param {string} id - รหัส id ของ modal
   * @param {string} body - รายละเอียดของ modal
   */
  setModalBody(element, body) {
    $(element).find('.modal-body').html(body);
  }
  /**
   * ตั้งค่าหัวข้อของ modal
   * @param {string} id - รหัส id ของ modal
   * @param {string} title - หัวข้อของ modal
   */
  setModalTitle(element, title) {
    $(element).find('.modal-title').html(title);
  }
}

